import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ComponentMeta, ComponentStory } from '@storybook/react'

import Typography from 'components/UI/Typography/Typography'

import typoArgs, { TypographyArgs } from './TypographyArgs'

export default {
  title: 'Typography',
  component: Typography.BodySmall,
} as ComponentMeta<typeof Typography.BodySmall>

const BodySmallTemplate: ComponentStory<typeof Typography.BodySmall> = (
  args: TypographyArgs,
) => <Typography.BodySmall {...args} />

const BodySmall = BodySmallTemplate.bind({})
BodySmall.args = typoArgs

export { BodySmall }
